import { clearCachedAppSession } from '../auth/session-cache';

export const SESSION_EXPIRED_EVENT = 'couplespace:session-expired';

/** Turn an API error body into a short user-facing message (never raw JSON). */
export function formatApiErrorBody(text: string, status: number): string {
  const trimmed = text.trim();
  if (!trimmed) {
    return `Request failed (${status})`;
  }
  try {
    const parsed = JSON.parse(trimmed) as {
      error?: { code?: string; message?: string };
      message?: string;
    };
    const fromEnvelope = parsed.error?.message;
    if (fromEnvelope) {
      return fromEnvelope;
    }
    if (parsed.message) {
      return parsed.message;
    }
  } catch {
    // not JSON — use plain text if it looks like a sentence, not a blob
  }
  if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
    return `Request failed (${status})`;
  }
  return trimmed;
}

export function notifySessionExpired(): void {
  clearCachedAppSession();
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
  }
}

export function apiErrorFromResponse(status: number, text: string): Error {
  if (status === 401) {
    notifySessionExpired();
    return new Error('Session expired — please sign in again.');
  }
  return new Error(formatApiErrorBody(text, status));
}

/** A block read or delete failed because the row is already gone. */
export function isMissingBlockError(err: unknown): boolean {
  if (!(err instanceof Error)) {
    return false;
  }
  const message = err.message.trim();
  if (/^(not found|block not found|page not found)$/i.test(message)) {
    return true;
  }
  if (/delete failed \(404\)/i.test(message)) {
    return true;
  }
  return /"code"\s*:\s*"NOT_FOUND"/.test(message);
}
